<template>
  <li
    class="tw-flex tw-items-center tw-justify-between tw-gap-2 tw-border tw-border-solid tw-border-slate-300 tw-rounded-lg tw-p-2 tw-cursor-pointer tw-bg-white hover:tw-bg-slate-100"
    @click="emit('click')"
  >
    <div class="tw-flex tw-items-center tw-gap-2">
      <i
        class="fa fa-check tw-text-emerald-400 tw-text-sm"
        :class="{ 'tw-opacity-0': !selected && !linked }"
      />

      <div class="tw-flex tw-flex-col">
        <span class="tw-text-xs">{{ dateString }}</span>
        <span>{{ meeting.title || 'Untitled Meeting' }}</span>

        <div
          class="tw-flex tw-flex-wrap tw-gap-1 tw-items-center tw-py-1 tw-text-xs"
          :title="meeting.attendees.join(', ')"
        >
          <span
            v-for="attendee in meeting.attendees.slice(0, 2)"
            :key="attendee"
            :class="[
              'tw-bg-slate-200',
              'tw-rounded-full',
              'tw-px-1.5 tw-py-0.5',
            ]"
          >
            {{ attendee }}
          </span>

          <span
            v-if="meeting.attendees.length > 2"
            class="tw-px-1.5 tw-py-0.5"
          >
            and {{ meeting.attendees.length - 2 }} more
          </span>
        </div>
      </div>
    </div>

    <i
      v-if="icon"
      :class="[
        'fa', props.icon,
        'tw-text-sm tw-px-2',
        'tw-text-rose-500',
        'tw-opacity-20'
      ]"
    />
  </li>
</template>


<script setup>
import { ref, reactive, computed, watch, onMounted, defineEmits, defineProps } from 'vue';

// Pinia stores
// import { useAdvisorStore } from '@frontend/ui/stores/advisorStore.js';
// const advisorStore = useAdvisorStore();


// Props
const props = defineProps({
  meeting: { type: Object, required: true },
  selected: { type: Boolean, default: false },
  linked: { type: Boolean, default: false },
  icon: { type: String, default: null },
});


// Reactive state

// For primitives, arrays, or shallow reactivity of objects
const count = ref(props.initialCount);
const date = ref(new Date(props.meeting.meeting_date));

// For deep reactivity of objects
const data = reactive({ count: 0 });


// Computed props
const doubleCount = computed(() => count.value * 2);

const dateString = computed(() => {
  return date.value.toLocaleString('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
});


// Watchers

// When you want to watch a primitive value or react to the entire object changing
watch(count, (newValue, oldValue) => {
  console.log(`Count changed from ${oldValue} to ${newValue}`);
});

// When you want to watch a computed prop or the specific property of an object
// Also works for primitive values
watch(() => doubleCount.value, (newValue, oldValue) => {
  console.log(`Double changed from ${oldValue} to ${newValue}`);
});


// Regular methods

const increment = () => {
  count.value++;
};

// Fetching data from backend
/*
  const fetchData = async () => {
    const res = await fetch('/api/v1/records', {
      method: 'GET',
      headers: advisorStore.headers,
    });
    const data = await res.json();
  }; */


// Events
const emit = defineEmits(['click']);


// Lifecycle hooks
onMounted(() => {
  console.log('Component mounted');
});


</script>


<style scoped>
li:hover > i {
  opacity: 1;
}
</style>
